export default __webpack_public_path__ + "static/project-start1-1be0b8fc393fdfc54071323af0ea2489.png";